import { Button, Divider, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { PimDashboardState } from "context/PimDashboardContext";
import { attrValAssocObj } from "../../Designer/DesignerAttributes/data";
import FabricTable from "./FabricTable/FabricTable";
import { defaultFabricTotalRow, dummyFabricTableData } from "./FabricTable/data";
import SewingTrimsTable from "./SewingTrimsTable/SewingTrimsTable";
import { dummySewingTrimsTableData, sewingTrimsPrefilledData } from "./SewingTrimsTable/data";
import ValueAdditionTable from "./ValueAdditionTable/ValueAdditionTable";
import GarmentTotalTable from "./GarmentTotalTable/GarmentTotalTable";
import { dummyDynamicTrimsTableData } from "./DynamicTrimConsumption/data";
import { otherChargesDefaultData } from "./FinalTotalTable/data";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import RenderAttributeInputs from "components/PimDashboard/CommonComponents/RenderAttributeInputs/RenderAttributeInputs";
import { AddRounded } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import {
	costingUrlKey,
	filterRequiredStyleColumns,
	openCostingFabricAssocObjKey,
	openCostingOtherChargesAssocObjkey,
	openCostingPackingTrimsAssocObjKey,
	openCostingPoCostAssocObjkey,
	openCostingSewingTrimsAssocObjKey,
	openCostingTrimsDynamicConsumpAssocObjKey,
	openCostingValueAddAssocObjKey,
	paymentTermColumn,
	removeKeyFromArrOfObj,
	supplierColumn,
	totalQtyColumn,
} from "./data";
import { useEffect, useState } from "react";
import { constraintsOptions, getColDefaultValue, isColumnDefault, selectedOpenCostingPath } from "components/PimDashboard/data";
import AddFileButton from "components/PimDashboard/CommonComponents/AddFileButton/AddFileButton";
import FinalTotalTable from "./FinalTotalTable/FinalTotalTable";
import PoCostTable from "./PoCostTable/PoCostTable";
import { postCostTableDefaultData } from "./PoCostTable/data";
import { GlobalState } from "context/GlobalContext";
import { AuthState } from "context/AuthContext";
import { allBrands, inputTypes, statusOptions } from "data/globalData";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import DynamicTrimConsumption from "./DynamicTrimConsumption/DynamicTrimConsumption";
import PackingTrimsTable from "./PackingTrimsTable/PackingTrimsTable";
import { packingTrimsPrefilledData } from "./PackingTrimsTable/data";

const imgWidth = 170;
const imgHeight = 210;

const CreateOpenCosting = () => {
	const { allAttributesObj: styleAllAttributesObj } = PimDashboardState();
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();
	const navigate = useNavigate();
	const [styleImage, setStyleImage] = useState({});

	const [optionDetails, setOptionDetails] = useState({});
	const [optionDetailsColumns, setOptionDetailsColumns] = useState([]);

	const [fabricRows, setFabricRows] = useState(
		// dummyFabricTableData
		[]
	);
	const [fabricTotalRow, setFabricTotalRow] = useState(defaultFabricTotalRow);
	const [sewingTrimsRows, setSewingTrimsRows] = useState(
		// dummySewingTrimsTableData
		[]
	);
	const [sewingTrimsTotalRow, setSewingTrimsTotalRow] = useState({ id: new Date().valueOf() });
	const [packingTrimsRows, setPackingTrimsRows] = useState([]);
	// dummyPackingTrimsTableData
	const [dynamicTrimsRows, setDynamicTrimsRows] = useState([]);
	// dummyDynamicTrimsTableData,[]
	const [packingTrimsTotalRow, setPackingTrimsTotalRow] = useState({ id: new Date().valueOf() });
	const [dynamicTrimsTotalRow, setDynamicTrimsTotalRow] = useState({ id: new Date().valueOf() });
	const [valueAddRows, setValueAddRows] = useState([]);
	// dummySewingTrimsTableData
	const [valueAddTotalRow, setValueAddTotalRow] = useState({ id: new Date().valueOf() });
	const [finalTotalRows, setFinalTotalRows] = useState([...otherChargesDefaultData]);
	const [poCostRows, setPoCostRows] = useState([...postCostTableDefaultData]);
	const [finalTotal, setFinalTotal] = useState({ id: new Date().valueOf() });
	const [garmentTotal, setGarmentTotal] = useState({});

	useEffect(() => {
		if (styleAllAttributesObj && !optionDetailsColumns?.length) {
			const columns = filterRequiredStyleColumns(styleAllAttributesObj)?.map((attr) => {
				if (
					attr?.key !== "brand" &&
					(attr?.input_type === inputTypes.SELECT.key || attr?.input_type === inputTypes.MULTIPLE_SELECT.key)
				)
					return { ...attr, input_type: inputTypes.ENTER.key };
				return attr;
			});
			setOptionDetailsColumns(columns);
			setOptionDetails(
				columns?.reduce((acc, row) => {
					acc[row?.key] = getColDefaultValue(row);
					return acc;
				}, {})
			);
		}
	}, []);
	useEffect(() => {
		if (optionDetails?.brand === allBrands.RAREISM.key && !sewingTrimsRows?.length) {
			setSewingTrimsRows(sewingTrimsPrefilledData);
		}
		if (optionDetails?.brand === allBrands.RAREISM.key && !packingTrimsRows?.length) {
			setPackingTrimsRows(packingTrimsPrefilledData);
		}
	}, [optionDetails]);

	const handleImageSelect = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();
		reader.onloadend = () => setStyleImage({ file, url: reader.result });
		reader.readAsDataURL(file);
	};
	const handleFileUpload = async (images) => {
		// append formdata with multiple file and its name

		const uploadModalProfileImgs = async () => {
			const formData = new FormData();
			images?.forEach((image) => {
				formData.append("images", image.file);
			});

			const res = await axios.post("/api/sourcing/upload_costing_images", formData, {
				headers: {
					"content-type": "multipart/form-data",
				},
			});

			return res.data.result;
		};
		if (!images.length) return [];

		const [resultImages] = await Promise.all([uploadModalProfileImgs()]);
		return [resultImages];
	};

	const handleFormSubmit = async () => {
		setLoadingOpen(true);
		// if (!styleImage.file) {
		// 	setSnackBarOpen(true);
		// 	setSnackBar({
		// 		...snackBar,
		// 		message: "Add Image",
		// 		severity: "error",
		// 		anchorOrigin: { horizontal: "center", vertical: "top" },
		// 	});
		// 	setLoadingOpen(false);

		// 	return;
		// }

		let pendingFields = [];
		[...optionDetailsColumns, paymentTermColumn, totalQtyColumn, supplierColumn]
			.filter((row) => row?.input_type !== inputTypes.AUTO_GENERATE.key)
			.forEach((attr) => {
				let obj = optionDetails;
				if (isColumnDefault(attr, obj?.[attr?.key]) && attr?.constraints[constraintsOptions.NOTNULL.key])
					pendingFields.push(attr);
			});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}

		const sysData = {
			last_updated_by: user?.email,
			created_by: user?.email,
			status: statusOptions.CREATED.key,
		};

		try {
			let [images] = await handleFileUpload([...(styleImage?.file ? [styleImage] : [])], []);

			const body = {
				...optionDetails,
				...sysData,
				url: images?.[0]?.publicUrl ?? "",
				[openCostingFabricAssocObjKey]: removeKeyFromArrOfObj(fabricRows, "id"),
				[openCostingSewingTrimsAssocObjKey]: removeKeyFromArrOfObj(sewingTrimsRows, "id"),
				[openCostingPackingTrimsAssocObjKey]: removeKeyFromArrOfObj(packingTrimsRows, "id"),
				[openCostingTrimsDynamicConsumpAssocObjKey]: removeKeyFromArrOfObj(dynamicTrimsRows, "id"),
				[openCostingValueAddAssocObjKey]: removeKeyFromArrOfObj(valueAddRows, "id"),
				[openCostingOtherChargesAssocObjkey]: removeKeyFromArrOfObj(finalTotalRows, "id"),
				[openCostingPoCostAssocObjkey]: removeKeyFromArrOfObj(poCostRows, "id"),
			};

			// console.log("stylesty", body);

			const { data } = await axios.post("/api/sourcing/create_open_costing", body);
			console.log("res.data", data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Costing Sheet created successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			navigate(`/${selectedOpenCostingPath}?${costingUrlKey}=${data?.result?.style_ref_no}`);
			setLoadingOpen(false);
		} catch (error) {
			console.log(error, "ddsfdghjkl");
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		}
	};
	return (
		<Stack spacing={2} pt={2} pb={10}>
			{/* <Divider /> */}
			<Box display="flex" justifyContent="space-between" width="100%" columnGap="2%">
				{/* left */}
				<Stack>
					<Box display="flex" width="100%" pb={1} justifyContent="space-between">
						{styleImage?.file && (
							<>
								<Typography variant="h6">Image</Typography>
								<AddFileButton name={"Add Image"} onChange={handleImageSelect} sx={{}}>
									<Button
										sx={{ textTransform: "capitalize" }}
										size="small"
										// startIcon={<AddRounded />}
										variant="outlined">
										Update Image
									</Button>
								</AddFileButton>
							</>
						)}
					</Box>
					<Box
						width={imgWidth}
						height={imgHeight}
						sx={{ border: `1px solid ${grey[200]}` }}
						display="flex"
						alignItems="center"
						justifyContent="center">
						{!styleImage?.file ? (
							<Box>
								<AddFileButton name={"Add Image"} onChange={handleImageSelect} sx={{}}>
									<Button size="large" startIcon={<AddRounded />}>
										Add Image
									</Button>
								</AddFileButton>
							</Box>
						) : (
							<Box width={imgWidth} height={imgHeight} display="flex" flexWrap="wrap" rowGap={2}>
								<ImageSlider imgWidth={imgWidth} imgHeight={imgHeight} column="url" images={[styleImage]} />
							</Box>
						)}
					</Box>
				</Stack>
				{/* <Divider orientation="vertical" flexItem /> */}
				{/* right */}
				<Box sx={{ minWidth: "50%" }} flexGrow={1}>
					<Typography variant="h6">Option Details</Typography>
					<RenderAttributeInputs
						columns={optionDetailsColumns}
						setData={setOptionDetails}
						data={optionDetails}
						selectOptObjOptName={attrValAssocObj}
						inputWidth="30%"
					/>
					<RenderAttributeInputs
						columns={[totalQtyColumn, supplierColumn]}
						setData={setOptionDetails}
						data={optionDetails}
						selectOptObjOptName={""}
						inputWidth="30%"
					/>
				</Box>
			</Box>
			<FabricTable
				rows={fabricRows}
				setRows={setFabricRows}
				totalRow={fabricTotalRow}
				setTotalRow={setFabricTotalRow}
				mode="create"
			/>
			<SewingTrimsTable
				rows={sewingTrimsRows}
				setRows={setSewingTrimsRows}
				totalRow={sewingTrimsTotalRow}
				setTotalRow={setSewingTrimsTotalRow}
				mode="create"
			/>
			<PackingTrimsTable
				rows={packingTrimsRows}
				setRows={setPackingTrimsRows}
				totalRow={packingTrimsTotalRow}
				setTotalRow={setPackingTrimsTotalRow}
				mode="create"
			/>
			<DynamicTrimConsumption
				rows={dynamicTrimsRows}
				setRows={setDynamicTrimsRows}
				totalRow={dynamicTrimsTotalRow}
				setTotalRow={setDynamicTrimsTotalRow}
				mode="create"
			/>
			<ValueAdditionTable
				rows={valueAddRows}
				setRows={setValueAddRows}
				totalRow={valueAddTotalRow}
				setTotalRow={setValueAddTotalRow}
				mode="create"
			/>

			<Box display="flex" width="100%" justifyContent="space-around">
				<Box width="40%">
					<GarmentTotalTable
						rows={[fabricTotalRow, sewingTrimsTotalRow, packingTrimsTotalRow, dynamicTrimsTotalRow, valueAddTotalRow]}
						setRows={() => {}}
						garmentTotal={garmentTotal}
						setGarmentTotal={setGarmentTotal}
					/>
				</Box>
				<Box width="55%">
					<FinalTotalTable
						finalTotal={finalTotal}
						setFinalTotal={setFinalTotal}
						rows={finalTotalRows}
						setRows={setFinalTotalRows}
						garmentTotalObj={garmentTotal}
						optionDetails={optionDetails}
						mode="create"
					/>
				</Box>
			</Box>
			<PoCostTable
				rows={poCostRows}
				setRows={setPoCostRows}
				finalTotalObj={finalTotal}
				optionDetails={optionDetails}
				setOptionDetails={setOptionDetails}
				mode="create"
			/>
			<Button
				sx={{ position: "fixed", left: "50%", bottom: "10px", transform: "translate(-50%,0%)" }}
				size="large"
				variant="contained"
				onClick={handleFormSubmit}>
				Create and Save
			</Button>
		</Stack>
	);
};

export default CreateOpenCosting;
